import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import jQuery from "jquery";
import "jquery-ui/ui/widgets/datepicker";

// import { globalCookiesConfig } from "vue3-cookies";

// globalCookiesConfig({
//   expireTimes: "30d",
//   path: "/",
//   domain: "",
//   secure: true,
//   sameSite: "None",
// });

const app = createApp(App);
app.provide("url_prefix", "/api/" + process.env.VUE_APP_API_V);
app.use(router);
app.use(createPinia());
app.use(store);
app.mount("#app");
global.$$ = jQuery;
